/*
 * @Author: ken yang
 * @Date: 2023-03-01 19:04:55
 * @LastEditTime: 2023-03-01 21:43:13
 * @LastEditors: ken yang
 * @Description: 表格滚动生成高度插件
 * @FilePath: /uexch_admin/src/utils/plugins/tableScroll.js
 */
export default {
  install: (app, options) => {
    app.mixin({
      mounted () {
        // const height = document.getElementsByClassName('DynamicForm')[0]?.offsetHeight + 220
        // app.config.globalProperties.tableHeight = `calc(100vh - ${height}px)`
        // if (this.$options.__name === 'App') {
        //   window.addEventListener('resize', (e) => {
        //     const height = document.getElementsByClassName('DynamicForm')[0].offsetHeight + 220
        //     globalThis.tableHeight = `calc(100vh-${height})`
        //   })
        // }
        // const headerDom = document.getElementsByClassName('hhh')[0]
        // console.log('0000', headerDom?.offsetWidth)

        // const headerWidth = document.getElementsByClassName('hhh')[0]?.offsetWidth
        // window.addEventListener('scroll', () => {
        //   const dom = document.getElementsByClassName('fff')[0]
        //   const toTop = dom?.getBoundingClientRect().top
        //   const headerDom = document.getElementsByClassName('hhh')[0]
        //   headerDom.style.position = 'sticky'
        //   headerDom.style.top = '0px'
        //   if (toTop < 1) {
        //     headerDom.style.position = 'sticky'
        //     headerDom.style.top = '0px'
        //     headerDom.style['z-index'] = '1999'
        //     headerDom.style.width = '3072px'
        //   } else {
        //     headerDom.style.position = 'unset'
        //   }
        // }, true)
      }
    })
  }
}
